
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.886 0a2.84 2.84 0 00-2.829 2.83v12.343A2.84 2.84 0 004.886 18h8.228a2.84 2.84 0 002.829-2.828V5.888c0-.71-.267-1.396-.75-1.918L12.37.91A2.832 2.832 0 0010.29 0H4.887zm0 1.543h4.811a.771.771 0 00-.044.257v2.057a2.84 2.84 0 002.828 2.829H14.4v8.486c0 .719-.566 1.285-1.286 1.285H4.886c-.72 0-1.286-.566-1.286-1.285V2.829c0-.72.566-1.286 1.286-1.286zm6.31.396c.01.01.03.007.04.018l2.822 3.06c.032.034.023.089.05.126h-1.627a1.273 1.273 0 01-1.285-1.286V1.94z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"d":"M6.155 10.288a.771.771 0 100 1.542h5.818a.771.771 0 100-1.542z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    